<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="finance" pageId="reimbursements-review" color="white"></help-link>
                    <v-menu v-if="!loading" left v-model="menu_status" offset-y :disabled="!enableForEditRights&&!enableForApproverRights"> 
                        <template v-slot:activator="{ on }">
                            <v-btn :color="commonfn.getStatusButtonColor(reimbursement_status)" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;{{commonfn.getStatusDescription(reimbursement_status)}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" @click="showEdit" :key="1" title="Edit Reimbursements">
                                <v-list-tile-title small>Edit</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" @click="setForReview" :key="2" title="Set to For Review">
                                <v-list-tile-title small>For Review</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasApproverRights&&(forReview_status||rejected_status)" :key="3" @click="approve" title="Approve Reimbursement">
                                <v-list-tile-title small>Approve</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasApproverRights&&(forReview_status||approved_status)" :key="4" @click="reject" title="Reject Reimbursement">
                                <v-list-tile-title small>Reject</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>

            <!-- details -->
            <v-card v-if="!loading" class="elavation-1" style="margin-top:10px;"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold ">SUMMARY</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-layout row wrap :class="isMobile?'form-row-mobile':'form-row'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Employee :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    <v-chip @click="viewUserProfile(reimbursement_detail, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(reimbursement_detail.userId)"></v-img>
                                        </v-avatar>
                                        {{reimbursement_detail.name}} 
                                    </v-chip>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'form-row-mobile':'form-row'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Type :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    {{reimbursement_detail.reimbursementType}} 
                                </v-flex>  
                            </v-layout>    
                            <v-layout row wrap :class="isMobile?'form-row-mobile':'form-row'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Amount :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                PHP {{numFormat.formatNumber(reimbursement_detail.amount)}} 
                                </v-flex>  
                            </v-layout> 
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-layout row wrap :class="isMobile?'form-row-mobile':'form-row'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Remarks :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    {{reimbursement_detail.description}}
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'form-row-mobile':'form-row'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Created On :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    {{reimbursement_detail.createdOn | moment('MMM DD, YYYY')}} 
                                </v-flex>  
                            </v-layout>
                        </v-flex> 
                    </v-layout>
                </v-card-text>    
            </v-card>
           
            <!-- attachments -->
            <v-card v-if="!loading" class="elavation-1" style="margin-top:10px;"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold ">ATTACHMENTS</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="enableForEditRights" icon title="Add Attachments" @click="showUpload">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="attachments"
                    :hide-actions="attachments.length<6"
                    :loading="loading_attachment"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr>
                            <td @click="previewAttachment(props.item)" style="cursor:pointer;" title="Click to preview file">
                                <span class="clickable">
                                    {{ props.item.filename }}
                                </span>
                            </td>
                            <td>{{ props.item.createdOn | moment('MMM DD, YYYY') }}</td>
                            <td>
                                <v-btn v-if="enableForEditRights" icon title="Remove Attachments" @click="removeAttachment(props.item)">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </td> 
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
            
            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedReimbursementsId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>
        
         <v-dialog v-model="dialogDelete" width="500">
            <v-card class="elavation-1" style="border-radius:4px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">Confirm Delete</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="text-xs-center">
                    <p>Delete attachment?</p>
                    <p>Note: you will not be able to undo this operation.</p>
                </v-card-text>
                 <v-divider></v-divider>
                 <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn title="Delete" class="red" dark @click="deleteAttachment" :loading="loading_delete">Delete</v-btn>
                    <v-btn title="Cancel" @click="dialogDelete=false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAddEdit" width="500" persistent :fullscreen="isMobile">   
            <add-edit ref="addEditRef" :dialogAddEdit.sync="dialogAddEdit" @send="getReimbursementsDetail(false)"></add-edit>
        </v-dialog>
        <v-dialog v-if="reimbursement_detail" v-model="dialogUpload" fullscreen hide-overlay transition="dialog-bottom-transition"> 
            <upload ref="uploadRef" :itemUserId="itemUserId" :pageKey="userPageKey" :dialogUpload.sync="dialogUpload" @send="getReimbursementsDetail(false)"></upload>
        </v-dialog>
        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedReimbursementsId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import commonfn from '@/common/functions'
import reimbursementsApi from '@/api/reimbursements'
import commonData from '@/common/data'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'

export default {     
    name: 'MyReimbursements',
    metaInfo: {
        title: 'My Reimbursements',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create My Reimbursementss' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit': () => import('@/components/Reimbursements/AddEditReimbursements'),
        'upload': () => import('@/components/Reimbursements/AddAttachments'),
        'preview': () => import('@/components/FilePreview/Preview'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            common_data: null,
            error: false,
            errorMessage: '',
            dialogPreview: false,
            loading: false,
            loading_status: false,
            loading_attachment: false,
            menu_status: false,
            loading_delete: false,
            dialogDelete:false,
            headers: [
                    {text: 'File',align: 'left',value: 'name', width: '70%', sortable:false},
                    {text: 'Created On',align: 'left',value: 'status',  width: '25%', sortable:false},
                    {text: '',align: 'left',value: '',  width: '5%', sortable:false}
                ],
            dialogAddEdit: false,
            dialogUpload: false,
            panel: [true, true],
            reimbursement_detail: null,
            attachments: [],
            delete_reimbursementAttachmentId: null,
        }
    },
    methods: {
        async previewAttachment(item) {
            try {
                this.loading_attachment = true 
                const response = await reimbursementsApi.getAttachmentUrl(this.itemUserId, item.filename, this.userPageKey)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(this.itemUserId, response.data.fileName, AWSS3DocumentType.Reimbursements)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading_attachment = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async deleteAttachment() {
            try {                
                this.loading_delete = true
                //remove attachment from upload directory then delete attachment from db
                const response = await reimbursementsApi.deleteAttachment(this.delete_reimbursementAttachmentId)
                if (response.status == 200) {
                    await this.getReimbursementsDetail(false)
                }
                this.loading_delete = false
                this.dialogDelete = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        removeAttachment(data){
            this.delete_reimbursementAttachmentId = data.reimbursementAttachmentId
            this.dialogDelete = true
        },
        showUpload(){
            this.dialogUpload = true
            this.$refs.uploadRef.setData(this.selectedReimbursementsId)
        },
        async setForReview() {
            try {
                this.loading_status = true
                var data = {
                    reimbursementsId : this.selectedReimbursementsId
                }
                const response = await reimbursementsApi.setForReview(data, this.userPageKey)
                if (response.status == 200) {
                    await this.getReimbursementsDetail(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try {
                this.loading_status = true
                var data = {
                    reimbursementsId : this.selectedReimbursementsId
                }
                const response = await reimbursementsApi.reject(data)
                if (response.status == 200) {
                    await this.getReimbursementsDetail(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approve() {
            try {
                this.loading_status = true
                var data = {
                    reimbursementsId : this.selectedReimbursementsId
                }
                const response = await reimbursementsApi.approve(data)
                if (response.status == 200) {
                    await this.getReimbursementsDetail(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showEdit() {
            this.$refs.addEditRef.setUpdate(this.reimbursement_detail, this.userPageKey)
            this.dialogAddEdit = true
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
        async getReimbursementsDetail(show_loading) {
            try {
                this.loading = show_loading
                const response = await reimbursementsApi.getMyReimbursementsDetail(this.selectedReimbursementsId)
                if (response.status == 200) {
                    this.reimbursement_detail = response.data
                    this.attachments = response.data.attachments
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getReimbursementsDetail(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        this.commonfn = commonfn
        this.common_data = commonData
        this.numFormat = numFormat
        this.awsS3Helper = awsS3Helper
        
        await this.getReimbursementsDetail(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.viewedByOwner?'My ':''}Reimbursement Details`
        })
    },
    computed: {
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return commonfn.hasApproverRights(this.$router.currentRoute.path)
        },
        selectedReimbursementsId() {
            return this.$route.params.reimbursementsId
        },
        itemUserId() {
            if (this.reimbursement_detail) { 
                return this.reimbursement_detail.userId
            }
        },
        viewedByOwner() {
            if (this.reimbursement_detail!=null) {
                return this.$store.state.userId == this.reimbursement_detail.userId
            }
        },
        viewedByItemCreator() {
            if (this.reimbursement_detail!=null) {
                return this.$store.state.userId == this.reimbursement_detail.createdBy
            }
        },
        userPageKey() {
            return this.viewedByOwner ? pageKeys.myreimbursements : pageKeys.reimbursements
        },
        pageLink() {
            if (this.reimbursement_detail!=null) {
                if (this.viewedByOwner||this.viewedByItemCreator) {
                    return this.$router.currentRoute.path.replace('/myreimbursements/','/reimbursements/') //should send to approver
                }else{
                    return this.$router.currentRoute.path.replace('/reimbursements/','/myreimbursements/') //should send to owner
                }
            }
        },
        commentsData() {
            if (this.reimbursement_detail!=null) {
                return {
                    pageQueryId: this.selectedReimbursementsId,
                    pageItemCreatedBy: this.reimbursement_detail.userId,
                    pageLink: this.pageLink,
                    pageKey: pageKeys.reimbursements,
                    notificationTypeId: notificationTypes.reimbursements
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
        reimbursement_status() {
            if (this.reimbursement_detail!=null) return this.reimbursement_detail.status
        },
        created_status() {
            if (this.reimbursement_detail!=null) return this.reimbursement_detail.status==commonfn.getStatusCode('Created')
        },
        forReview_status() {
            if (this.reimbursement_detail!=null) return this.reimbursement_detail.status==commonfn.getStatusCode('For Review')
        },
        approved_status() {
            if (this.reimbursement_detail!=null) return this.reimbursement_detail.status==commonfn.getStatusCode('Approved')
        },
        credited_status() {
            if (this.reimbursement_detail!=null) return this.reimbursement_detail.status==commonfn.getStatusCode('Credited')
        },
        rejected_status() {
            if (this.reimbursement_detail!=null) return this.reimbursement_detail.status==commonfn.getStatusCode('Rejected')
        },
        processed_status() {
            if (this.reimbursement_detail!=null) return this.reimbursement_detail.status==commonfn.getStatusCode('Processed')
        },
        enableForApproverRights() {
            return this.hasApproverRights&&(this.forReview_status||this.rejected_status||this.approved_status)
        },
        enableForEditRights() {
            return this.hasEditRights&&(this.created_status||this.rejected_status)
        }
    }
}
</script>
<style scoped>
.form-row-mobile {
    padding:0px 20px 0px 20px;
}
.form-row {
    padding:0px 20px 0px 50px;
}
.clickable:hover{
    text-decoration: underline;
}
</style>